import { render } from "./Create.vue?vue&type=template&id=26fd66b4&lang=pug"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"

import "./Create.vue?vue&type=style&index=0&id=26fd66b4&lang=scss"
script.render = render

export default script